module.exports = __webpack_public_path__ + "img/banner2.292646c6.png";